import { Droplet, Egg, Beef } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { photoUrl, slugify, type SiteContent } from '../../utils/site';

export interface Product {
  name: string;
  description: string;
  icon: LucideIcon;
  image: string;
}

export interface ProductCategory {
  id: string;
  title: string;
  tagline: string;
  icon: LucideIcon;
  products: Product[];
}

// Source of truth: For Webpage_SKG.pptx ("Products" slide) — do not add
// product lines beyond what's confirmed there.
//
// Product photos (public/products/*.jpg) are stock images from Pixabay,
// used under the Pixabay Content License (free for commercial use, no
// attribution required): https://pixabay.com/service/license-summary/
// These are generic representative photos, NOT photos of this farm's own
// animals or production — swap in real photos whenever available.
/** The photo uploaded for this product (Administration -> Appearance -> Photos), else the stock one. */
export function productImage(site: SiteContent, product: Product): string {
  return photoUrl(site, `product.${slugify(product.name)}`) ?? product.image;
}

export const PRODUCT_CATEGORIES: ProductCategory[] = [
  {
    id: 'dairy',
    title: 'Milk & Dairy',
    tagline: 'Fresh from the herd, every single day.',
    icon: Droplet,
    products: [
      {
        name: 'Cow Milk',
        description: 'Fresh dairy milk.',
        icon: Droplet,
        image: '/products/cow-milk.jpg',
      },
      {
        name: 'Dairy By-Products',
        description: 'Paneer, Ghee, Curd, Butter.',
        icon: Droplet,
        image: '/products/dairy-byproducts.jpg',
      },
    ],
  },
  {
    id: 'poultry',
    title: 'Eggs',
    tagline: 'Wholesome eggs from well-cared-for birds.',
    icon: Egg,
    products: [
      {
        name: 'Hen Eggs',
        description: 'Farm-fresh eggs.',
        icon: Egg,
        image: '/products/hen-eggs.jpg',
      },
    ],
  },
  {
    id: 'sheep',
    title: 'Sheep',
    tagline: 'Responsibly raised sheep, quality assured.',
    icon: Beef,
    products: [
      {
        name: 'Sheep Meat',
        description: 'Quality sheep meat.',
        icon: Beef,
        image: '/products/sheep-meat.jpg',
      },
    ],
  },
];
